import React from "react";
import BeautyTreatment from "../../Components/treatmentCards/BeautyTreatment";
import {
  bodyShapping,
  botox,
  branch,
  coolSculpting,
  eyelash,
  hydra,
  hydrafacial,
  leaf2,
  lipFiller,
  lips,
  mainLeaf,
  mainLeaf2,
  wax,
} from "../../assets";

const Treatments = () => {
  return (
    <div id="treatments">
      <img src={mainLeaf} alt="" className="mainLeaf mleaf1" />
      <img src={mainLeaf} alt="" className="mainLeaf mleaf2" />
      <img src={mainLeaf} alt="" className="mainLeaf mleaf3" />
      <img src={leaf2} alt="" className="mainLeaf mleaf4" />
      <img src={branch} alt="" className="mainLeaf mleaf5" />
      <img src={mainLeaf2} alt="" className="mainLeaf mleaf6" />

      {/* <SectionTitle sub="Treatments" title="Our Beauty Treatments" /> */}

      <div className="mainContent">
        <BeautyTreatment
          id="asthetic"
          toLink="/asthetic-treatments"
          mainTitle="Asthetic"
          title="American and Korean Asthetic treatments right in Dhaka Bangladesh"
          subTitle="Looking for a reliable place for Asthetic treatments in Bangladesh? It’s easy to schedule an appointment at Metro Beauty Centers, conveniently located in Bangladesh."
          f1={lips}
          f2={eyelash}
          f3={wax}
          f1Title="Smooth out fine lines"
          f2Title="Smooth out wrinkles"
          f3Title="Restore youthfulness"
          mainLogo={hydrafacial}
          mainBanner={hydra}
        />

        <BeautyTreatment
          id="antiAging"
          toLink="/anti-aging-treatments"
          mainTitle="Anti-Aging"
          title="American and Korean Anti-Aging treatments right in Dhaka Bangladesh"
          subTitle="Looking for a reliable place for Botox in Bangladesh? It’s easy to schedule an appointment at Metro Beauty Centers, conveniently located in Bangladesh."
          f1={lips}
          f2={eyelash}
          f3={wax}
          f1Title="Boost your immunity"
          f2Title="Mobilizing own stem cells"
          f3Title="Improve circulation"
          mainLogo={hydrafacial}
          mainBanner={botox}
        />

        <BeautyTreatment
          id="bodyShaping"
          toLink="/body-shaping-treatments"
          mainTitle="Body Shaping"
          title="American and Korean Body Shaping right in Dhaka Bangladesh"
          subTitle="Looking for a reliable place for Body Shaping treatments in Bangladesh? It’s easy to schedule an appointment at Metro Beauty Centers, conveniently located in Bangladesh."
          f1={lips}
          f2={eyelash}
          f3={wax}
          f1Title="Rejuvenated aging skin"
          f2Title="Elimination of double chin"
          f3Title="Toned thighs"
          mainLogo={hydrafacial}
          mainBanner={bodyShapping}
        />

        <BeautyTreatment
          id="dermatology"
          toLink="/dermatology-treatments"
          mainTitle="Dermatology"
          title="American and Korean Dermatology right in Dhaka Bangladesh"
          subTitle="Looking for a reliable place for Dermatology in Bangladesh? It’s easy to schedule an appointment at Metro Beauty Centers, conveniently located in Bangladesh."
          f1={lips}
          f2={eyelash}
          f3={wax}
          f1Title="Prevention of Skin Issues"
          f2Title="Identifying Signs of Skin Cancer"
          f3Title="Professional Skincare Routines"
          mainLogo={hydrafacial}
          mainBanner={coolSculpting}
        />

        <BeautyTreatment
          id="sexology"
          toLink="/sexology-treatments"
          mainTitle="Sexology"
          title="American and Korean Sexology treatments right in Dhaka Bangladesh"
          subTitle="Looking for a reliable place for Sexology tretments in Bangladesh? It’s easy to schedule an appointment at Metro Beauty Centers, conveniently located in Bangladesh."
          f1={lips}
          f2={eyelash}
          f3={wax}
          f1Title="Identify low sex drive"
          f2Title="Relief pain during sex"
          f3Title="Improve pleasure"
          mainLogo={hydrafacial}
          mainBanner={lipFiller}
        />
      </div>
    </div>
  );
};

export default Treatments;
